import { WordsHskViewContent } from "#words-hsk-view-content";

export function WordsHskView() {
  return <WordsHskViewContent />;
}
